<template>
    <div :class="getEditClass">
        <div :class="[prefixCls + '-popper']">
            <div :class="[column.class||'' +' '+ prefixCls + '-content'+' table-edit-btn table-edit-com']" >
            <div v-for="(edit, index) in column.editList" :key="index" class="item-edit inline-block" v-if="edit.setNotVisible ? !edit.setNotVisible(column,row) : true" @click="showPopper(index)"  :style="{'width':edit.width+'px'}">
                <component
                :col="column"
                :row="row"
                :content="row[edit.key]"
                :editCfg="edit.editCfg||{}"
                :visible="myShowEdit[index].show"
                :always="edit.always"
                :editAlways="edit.editAlways"
                :validErr="validErr"
                :validMsg="validMsg"
                @onChange="onChange"
                @onChangeShowEdit="myOnChangeShowEdit(index,arguments)"
                @setColEditDisabled="setColEditDisabled"
                v-bind:is="'plug'+edit.type"
                ></component>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import plugbtn from "./btn.vue";
import pluginput from "./input.vue";
import plugtextarea from "./textarea.vue";
import plugdropdown from "./dropdown.vue";
import plugdate from "./date.vue";
import pluguser from "./user.vue";
import plugcheckbox from "./checkbox.vue";
import plugradio from "./radio.vue";
import pluglink from "./link.vue";
import plugnumber from "./number.vue";
import plugtabletip from "./tableTip.vue";
import plugtooltip from "../../tooltip/tooltip.vue";
const prefixCls = "table-edit";
export default {
  name: "plugCompoundEdit",
  components: {
    plugtooltip,
    plugbtn,
    pluginput,
    plugtextarea,
    plugdropdown,
    plugdate,
    pluguser,
    plugcheckbox,
    plugradio,
    pluglink,
    plugnumber,
    plugtabletip
  },
  computed: {
    getEditClass() {
      return [
        `${this.prefixCls}`,
        {
          [`${this.prefixCls}-visible`]:this.visible,
          [`${this.prefixCls}-always`]:(this.editAlways || this.always) && !this.visible,
          [`${this.prefixCls}-disabled`]: this.getDisabled(),
          [`${this.prefixCls}-cell-valid-err`]:
            this.validErr === true && !this.visible
        }
      ];
    },
    getMyShowEdit(index){
        this.myShowEdit[index]=true
        return this.myShowEdit[index]
    }
  },

  props: {
    column: [String, Number, Object],
    row: [String, Number, Object],
    rowOriginal: [String, Number, Object],
    editCfg: Object,
    showEdit: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    },
    always: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [String, Number]
    },
    validMsg: {
      type: String
    },
    validErr: {
      type: [String, Boolean]
    },
    onChange: {
      type: Function
    },
    onChangeShowEdit:{
        type: Function
    },
    setColEditDisabled: {
      type: Function
    }
  },
  data() {
    return {
      prefixCls: prefixCls,
      selectData: "",
      myDisabled: false,
      showTooltip: false,
      focus: true,
      validErrMsgTip: false,
      myShowEdit: [{show:false}],
      myAlways:false
    };
  },
  watch: {
    visible(newValue, oldValue) {
      if (newValue) {
        this.$nextTick(function() {
          this.focus = true;
        });
      }
    }
  },
  methods: {
    showPopper(index){
        if(!this.getDisabled()){
            this.myShowEdit[index].show=true
        }
    },
    myOnChangeShowEdit(index,[showEdit,value]) {
         this.myShowEdit[index].show=false
         this.$emit("onChangeShowEdit", showEdit,value);
    },
    getDisabled(item) {
      let myDisabled = this.editCfg.setDisabled
        ? this.editCfg.setDisabled(this.col, this.row, this.editCfg)
        : this.editCfg.disabled;
      if (myDisabled) {
        this.setColEditDisabled(myDisabled)
      }
      return myDisabled;
    }
  },
  created(){
      //初始化所有组件的显示状态为false
      this.column.editList.filter((item,index)=>this.myShowEdit.push({show:false})) 
  },
  mounted() {
    this.selectData = this.content;
  }
};
</script>




// WEBPACK FOOTER //
// src/components/common/table/plug/compoundEdit.vue